import React from 'react';
import PropTypes from 'prop-types';

import {Modal} from "../nimbus/modal";
import {AlertMixin, TranslationMixin} from '../../mixins';
import {Alert} from '../alert';
import {Button} from '../button';
import {Header} from '../header';
import {WithCommonTranslations} from '../hocs';
import {OrderInvoiceRefund} from './OrderInvoiceRefund';

import './OrderInvoiceModal.css';

export const OrderInvoiceModal = WithCommonTranslations(
    class extends AlertMixin(TranslationMixin(React.Component)) {
      constructor(props) {
        super(props);

        this.state = {
          alert: {
            display: false,
            type: 'default',
            message: '',
          },
        };

        this.handleClose = this.handleClose.bind(this);
      }

      handleClose() {
        this.props.onClose();
      }

      //unused, may change our minds later
      renderTotalDiscount(totalDiscount, subtotalBeforeDiscount) {
        if (totalDiscount) {
          return (
              <React.Fragment>
              <tr>
                <td>{this.getTranslation('LABEL_ORDER_SUBTOTAL')}</td>
                <td className="text-right">{subtotalBeforeDiscount}</td>
                <td></td>
              </tr>
              <tr className="discount-row">
                <td>{this.getTranslation(
                    'LABEL_TOTAL_ORDER_DISCOUNT')}</td>
                <td className="text-right"> -{totalDiscount}</td>
                <td></td>
              </tr>
              </React.Fragment>
          );
        }
      }

      renderTaxSummary(summaryTaxDetails, tax) {
        let jsx = [];
        let totalTaxLabel = this.getTranslation(
            'LABEL_ORDER_SALES_TAX');
        if (summaryTaxDetails) {
          if (summaryTaxDetails.length === 1){
            totalTaxLabel = this.getTranslation("LABEL_ORDER_TOTAL") + ` ${summaryTaxDetails[0].taxType}`;
          } else {
            jsx.push(summaryTaxDetails.map(d =>
                (<tr key={d.taxType}>
                  <td className="font-weight-normal">
                    {d.taxType}
                  </td>
                  <td className="text-right">{d.taxAmount}</td>
                  <td></td>
                </tr>),
            ));
          }
        }

        jsx.push(<tr key="total-tax">
          <td className="font-weight-bold">{totalTaxLabel}</td>
          <td></td>
          <td className="text-right">{tax}</td>
        </tr>)

        return jsx;
      }

      render() {
        const {orderDetails} = this.props;
        const orderNumber = orderDetails.orderNumber;

        let taxIdLabel = orderDetails.taxIdLabel;
        if (taxIdLabel && taxIdLabel.endsWith(":")){
          taxIdLabel = taxIdLabel.substring(0,taxIdLabel.length-1);
        }

        return (
            <Modal header={<Header level={1}>{this.getTranslation(
                'HEADER_ORDER_INVOICE')}
            </Header>}
                   onClose={this.handleClose} open={this.props.open}
                   onBackdropClick={this.handleClose}>
              <div className="orderInvoiceModal container-fluid">
                {this.state.alert.display &&
                <Alert ref={this.alertRef}
                       type={this.state.alert.type}>{this.state.alert.message}
                </Alert>}

                {orderDetails.title &&
                <p dangerouslySetInnerHTML={{
                  __html: orderDetails.title,
                }}></p>
                }

                <div className="row">
                  <div className="col-6">
                    {(orderDetails.soldBy || orderDetails.sellerTaxIds) &&
                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_SOLD_BY')}</span><br/>
                      {orderDetails.soldBy &&
                      orderDetails.soldBy.map((line, i) => (
                          <span key={i} className="d-block">{line}</span>
                      ))}
                      {orderDetails.sellerTaxIds &&
                      orderDetails.sellerTaxIds.map((line, i) => (
                          <span key={i} className="d-block">{line}</span>
                      ))}
                    </p>
                    }

                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_PURCHASE_DATE')}</span><br/>
                      {orderDetails.orderDate}</p>

                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_ORDER_NUMBER')}</span><br/>
                      {orderNumber}
                    </p>
                    {orderDetails.transactionId &&
                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_TRANSACTION_ID')}</span><br/>
                      {orderDetails.transactionId}
                    </p>}
                    {orderDetails.authCode &&
                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_AUTHENTICATION_ID')}</span><br/>
                      {orderDetails.authCode}
                    </p>}
                    {(orderDetails.cardLast4Digits || orderDetails.cardBrand) &&
                    <p>
                    <span className="font-weight-bold">{this.getTranslation(
                        'LABEL_PAYMENT_METHOD')}</span><br/>
                      {orderDetails.cardBrand ?
                          orderDetails.cardBrand :
                          this.getTranslation(
                              'LABEL_CREDIT_CARD')} {orderDetails.cardLast4Digits ?
                        this.getTranslation(
                            'LABEL_ENDING_IN') + ' ' +
                        orderDetails.cardLast4Digits :
                        ''}
                    </p>}
                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_BILL_TO')}</span><br/>
                      {orderDetails.billingFirstName} {orderDetails.billingLastName}<br/>
                      {orderDetails.billingAddress &&
                      <React.Fragment>
                        {orderDetails.billingAddress.addressLine1}<br/>
                        {orderDetails.billingAddress.city},&nbsp;
                        {orderDetails.billingAddress.state}&nbsp;
                        {orderDetails.billingAddress.zipCode}
                      </React.Fragment>
                      }
                    </p>
                    {orderDetails.companyName &&
                    <p>
                  <span className="font-weight-bold">{this.getTranslation(
                      'LABEL_COMPANY_NAME')}</span><br/>
                      {orderDetails.companyName}
                    </p>
                    }
                    {orderDetails.vat &&
                    <p>
                      <span className="font-weight-bold">
                        {taxIdLabel}</span><br/>
                      {orderDetails.vat}
                    </p>
                    }

                  </div>
                  <div className="col-6">
                    <p><span className="font-weight-bold">{this.getTranslation(
                        'LABEL_ORDER_STATUS')}</span><br/>
                      {orderDetails.receiptStatus}</p>
                  </div>
                </div>
                <table className="table">
                  <thead>
                  <tr>
                    <th>{this.getTranslation('LABEL_DESCRIPTION')}</th>
                    <th className="text-right">{this.getTranslation(
                        'LABEL_QUANTITY')}</th>
                    <th className="text-right">{this.getTranslation(
                        'LABEL_PRICE')}</th>
                  </tr>
                  </thead>
                  <tbody>
                  {orderDetails.receiptItems &&
                  orderDetails.receiptItems.map((item) => (
                      <React.Fragment key={item.itemId}>
                        <tr className="border-top">
                          <td>
                          <span
                              className="font-weight-bold">{item.name}</span> {item.skuDescription &&
                          <span>- {item.skuDescription}</span>}
                          </td>
                          <td className="text-right">{item.quantity}</td>
                          <td className="text-right">
                            {item.subtotalBeforeDiscount !==
                            item.subtotalAfterDiscount &&
                            <s>{item.subtotalBeforeDiscount}</s>} {item.subtotalAfterDiscount}
                            {item.displayableDiscount &&
                            <div className="discount-row font-italic">
                              {item.displayableDiscount}
                            </div>
                            }
                          </td>
                        </tr>
                        {item.taxDetails && item.taxDetails.map((tax) => (
                            <tr key={tax.taxType}>
                              <td colSpan="3" className="text-right">
                                {tax.taxType}<span
                                  className="ml-2">{tax.taxAmount}</span>
                                <br/>
                                <span
                                    className="font-italic">{tax.message}</span>
                              </td>
                            </tr>
                        ))}
                      </React.Fragment>
                  ))}
                  </tbody>
                </table>

                <div className="clearfix">
                  <table className="float-right total-table">
                    <tbody>
                    <tr>
                      <td className="font-weight-bold">{this.getTranslation('LABEL_ORDER_SUBTOTAL')}</td>
                      <td></td>
                      <td className="text-right">{orderDetails.subtotalAfterDiscount}</td>
                    </tr>
                    {this.renderTaxSummary(orderDetails.summaryTaxDetails, orderDetails.tax)}
                    <tr className="border-top">
                      <td className="font-weight-bold">{this.getTranslation('LABEL_ORDER_TOTAL')}</td>
                      <td></td>
                      <td className="text-right">{orderDetails.grandTotal}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <OrderInvoiceRefund
                    creditNote={orderDetails.creditNote}
                    receiptRefunds={orderDetails.receiptRefunds}/>

                <div className="mt-3 clearfix">
                  {this.props.leftButton}

                  <div className="float-right">
                    {this.props.rightButton}
                    <Button type="submit"
                            variant="primary"
                            onClick={this.handleClose}>
                      {this.getTranslation(
                          'BUTTON_CLOSE')}</Button>
                  </div>
                </div>
              </div>
            </Modal>
        );
      }
    },
);

OrderInvoiceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  leftButton: PropTypes.node,
  rightButton: PropTypes.node,
  orderDetails: PropTypes.object.isRequired,
};